import classNames from 'classnames';
import { DetailedHTMLProps, LabelHTMLAttributes } from 'react';

interface CheckboxLabelProps extends DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
  disabled?: boolean;
}

export default function CheckboxLabel({
  className,
  disabled,
  children,
  ...props
}: CheckboxLabelProps) {
  return (
    <label
      className={classNames(
        disabled ? 'text-slate-400' : 'cursor-pointer',
        '[&_input]:mt-1 flex space-x-2',
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
}
